import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LOGO_URL = "/logo.png";

export default function LegalLayout({ eyebrow, title, updated, children, testId }) {
    return (
        <div
            data-testid={testId}
            className="relative min-h-screen scratched-black grain overflow-x-hidden"
        >
            {/* Top bar */}
            <header className="relative border-b border-gold/20">
                <div className="mx-auto max-w-4xl px-6 md:px-10 h-20 flex items-center justify-between">
                    <Link
                        to="/"
                        data-testid="legal-home-link"
                        className="flex items-center gap-3 group"
                    >
                        <img
                            src={LOGO_URL}
                            alt="Nicholas Kraus Consulting"
                            className="h-11 w-11 object-contain"
                        />
                        <div className="leading-tight">
                            <div className="font-display text-sm tracking-[0.18em] text-cream uppercase">
                                Nicholas Kraus
                            </div>
                            <div className="text-[9px] tracking-[0.4em] text-gold uppercase">
                                Consulting
                            </div>
                        </div>
                    </Link>
                    <Link
                        to="/"
                        data-testid="legal-back-link"
                        className="inline-flex items-center gap-2 text-cream/70 hover:text-gold transition-colors text-xs uppercase tracking-[0.2em] font-semibold"
                    >
                        <ArrowLeft size={14} /> Back to Home
                    </Link>
                </div>
            </header>

            {/* Content */}
            <main className="relative mx-auto max-w-4xl px-6 md:px-10 py-16 md:py-24">
                <div className="flex items-center gap-3 mb-6">
                    <span className="h-px w-8 bg-gold" />
                    <span className="text-[10px] uppercase tracking-[0.4em] text-gold font-semibold">
                        {eyebrow}
                    </span>
                </div>
                <h1 className="font-display text-5xl md:text-6xl leading-[1] tracking-tight">
                    {title}
                </h1>
                {updated && (
                    <p className="mt-4 text-[10px] uppercase tracking-[0.3em] text-cream/50">
                        Last updated · {updated}
                    </p>
                )}

                <div className="mt-14 legal-prose text-cream/80 text-[15px] md:text-base leading-relaxed">
                    {children}
                </div>

                <div className="mt-20 border-t border-gold/15 pt-8 text-sm text-cream/60">
                    <div className="font-display text-xl text-cream mb-2">
                        Questions?
                    </div>
                    <p>
                        Contact us at{" "}
                        <a
                            href="mailto:nrkraus@nicholaskrausconsulting.com"
                            className="text-gold hover:text-gold-light"
                        >
                            nrkraus@nicholaskrausconsulting.com
                        </a>{" "}
                        or{" "}
                        <a
                            href="tel:+19373213576"
                            className="text-gold hover:text-gold-light"
                        >
                            937-321-3576
                        </a>
                        .
                    </p>
                </div>
            </main>

            <footer className="border-t border-gold/15 py-8 text-center text-[10px] uppercase tracking-[0.3em] text-cream/40">
                © {new Date().getFullYear()} Nicholas Kraus Consulting LLC · All rights reserved
            </footer>
        </div>
    );
}
